import {Logger} from '../utilities/logger';
import {AbstractView} from './abstract-view';
import {Modal} from '../components/modal';
import {A11yConsentApi} from '../a11y-consent-api';

/**
 * A view displaying consent information in a modal window.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class ModalView extends AbstractView {
  // Instance of the modal
  private modal: Modal;

  constructor(api: A11yConsentApi, container: HTMLElement) {
    super(api, container);
    Logger.debug('modal-view', 'Starting to construct.');

    this.modal = new Modal(this.api, this.container);

    Logger.debug('modal-view', 'Finished constructing.');
  }

  show(): void {
    this.emitter.emit('show', this);
    Logger.info('modal-view', 'Show.');
    this.modal.show();
    this.emitter.emit('shown', this);
  }

  hide(): void {
    this.emitter.emit('hide', this);
    Logger.info('modal-view', 'Hide.');
    this.modal.hide();
    this.emitter.emit('hidden', this);
  }
}
